import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";
import React, { useState } from "react";
import firebaseConfig from "../../fb.json";
import "../../styles/refund.css";
import {
  initBuilder,
  messageBuilderForFirebase,
  messageBuilderForPaypro,
  messageBuilderForStripe,
  objMap
} from "./messageBuilder";
import { logRefundActivity } from "../cms/activityLog";

// Initialize Firebase app
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);
if (window.location.hostname === "localhost" || window.location.protocol === "file:") {
  connectFunctionsEmulator(functions, "localhost", 5005);
}

const secretKeyPuur = "F2342f3rgwf1242gffsdfg234wdf2fr3ef3ef";

const Refund = () => {
  const fillPrefix = (prefix) => {
    setEmail(prefix);
    setTimeout(() => document.getElementById("email")?.focus(), 0);
  };

  const intialState = {
    htmlContent: (
      <div className="refund__hints">
        <p>Search by email, userID or Statement Descriptor</p>
        <div className="refund__hint-chips">
          <button className="refund__chip" onClick={() => fillPrefix("authcode: ")}>
            <span className="refund__chip-label">authcode:</span>
            <span className="refund__chip-example">00985S</span>
          </button>
          <button className="refund__chip" onClick={() => fillPrefix("tid: ")}>
            <span className="refund__chip-label">tid:</span>
            <span className="refund__chip-example">465211841106973</span>
          </button>
        </div>
      </div>
    )
  };

  const [email, setEmail] = useState("");
  const [htmlContent, setHtmlContent] = useState<any>(intialState.htmlContent);
  const [isSearching, setIsSearching] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [pendingAction, setPendingAction] = useState<any>(null);
  const [customRefundAmount, setCustomRefundAmount] = useState(0);
  const [customRefundAmountDisplay, setCustomRefundAmountDisplay] = useState("0.00");
  const [btnStates, setBtnStates] = useState<Record<string, any>>({});
  // btnStates: { [uniqueId]: { status: "loading" | "success" | "error", message: string } }

  const toMinorUnits = (displayAmount) => {
    if (!displayAmount || typeof displayAmount !== "string") return 0;
    const remainingMatch = displayAmount.match(/remaining\s*\$?([0-9.,]+)/i);
    if (remainingMatch && remainingMatch[1]) {
      const normalizedRemaining = remainingMatch[1].replace(/,/g, ".");
      const majorRemaining = parseFloat(normalizedRemaining);
      if (!Number.isNaN(majorRemaining)) return Math.max(0, Math.round(majorRemaining * 100));
    }
    const normalized = displayAmount.replace(/[^0-9.,-]/g, "").replace(",", ".");
    const major = parseFloat(normalized);
    if (Number.isNaN(major)) return 0;
    const minor = Math.round(major * 100);
    return minor > 0 ? minor : 0;
  };

  const getDataByEmail = async () => {
    let sanitized_input: any = { email: email?.trim() };
    if (!sanitized_input.email?.length) {
      setHtmlContent(<span style={{ color: "var(--color-warning)" }}>Please enter something</span>);
      return;
    }

    if (email?.trim().toLowerCase().includes("authcode:")) {
      sanitized_input = { authCode: email.toLowerCase().split("authcode:")[1].trim() };
    }
    if (email?.trim().toLowerCase().includes("tid:")) {
      sanitized_input = { tid: email.toLowerCase().split("tid:")[1].trim() };
    }

    setIsSearching(true);
    setHtmlContent([
      <div key="loading" className="refund__loader">
        <div className="refund__loader-dots">
          <span /><span /><span />
        </div>
        <span>Checking FB, Stripe, Paypro & Postmark...</span>
      </div>
    ]);

    initBuilder();

    const getFullUserDataEmail = httpsCallable(functions, "getFullUserDataEmail");

    try {
      const result = await getFullUserDataEmail({
        input: sanitized_input,
        k: secretKeyPuur,
        skipFormattedResponse: true
      });

      const res = result.data as any;
      const found_email = res.found_email;
      console.log("FullUserDataEmail results", res);
      let htmlToInsert = "";

      if (sanitized_input.authCode) {
        htmlToInsert += `<b><span style="color: var(--color-danger);">AuthCode is not UNIQUE! CHECK ASSET, DATE & AMOUNT</span></b><br><br>`;
      }
      if (sanitized_input.tid) {
        htmlToInsert += `<b><span style="color: var(--color-accent);">Transaction ID is UNIQUE (we believe it is)!</span></b><br><br>`;
      }

      const response = res.response.replace(/\n/g, "<br>");

      if (response?.length) {
        htmlToInsert += response + "<br><br>";
      }
      console.log("response", response);

      if (email?.trim() != found_email && found_email != null) {
        htmlToInsert += `Results for <u><b>${email?.trim()}</b></u> (email found: ${found_email}):<br><br>`;
      } else {
        htmlToInsert += `Results for <u><b>${email?.trim()}</b></u>:<br><br>`;
      }

      if (res?.users) {
        console.log("Users by Firebase", res.users);
        htmlToInsert += messageBuilderForFirebase("html", res.users, true);
      }

      if (res?.stripe) {
        htmlToInsert += messageBuilderForStripe("html", res.stripe);
      }

      if (res?.paypro) {
        htmlToInsert += messageBuilderForPaypro("html", res.paypro);
      }

      if (res?.postmark && res.postmark.length > 0) {
        htmlToInsert += `<br/><u><b>Email Evidence (Postmark)</b></u><br/>`;
        for (const pm of res.postmark) {
          htmlToInsert += `<b>[${pm.project}]</b><br/>`;
          for (const ev of pm.events) {
            htmlToInsert += `<b>${ev.type}</b>: ${ev.time}<br/>`;
          }
        }
      }

      const dynamicContent = htmlToInsert.split(/({"uniqueId".*?})/g).map((chunk, index) => {
        try {
          const parsed = JSON.parse(chunk);
          return { type: "button", ...parsed };
        } catch {
          return { type: "html", html: chunk, index };
        }
      });

      setHtmlContent(dynamicContent);
      setBtnStates({});
    } catch (error) {
      console.error("Error fetching data by email:", error);
      setHtmlContent(<span style={{ color: "var(--color-danger)" }}>{error.message}</span>);
    } finally {
      setIsSearching(false);
    }
  };

  const buttonAction = (uniqueId) => {
    console.log("buttonAction", uniqueId);
    const s = objMap.get(uniqueId);

    setPendingAction({ uniqueId, actionData: s });
    setShowConfirmation(true);
    if (s?.action === "refund50") {
      const remainingMinor = Number(s?.object?.remaining_minor) || 0;
      let baseMinor = remainingMinor;
      if (!baseMinor || baseMinor <= 0) {
        const amountDisplay = s?.object?.amount;
        const parsed = toMinorUnits(amountDisplay);
        baseMinor = parsed;
      }
      const defaultHalf = baseMinor > 0 ? Math.floor(baseMinor / 2) : 0;
      setCustomRefundAmount(defaultHalf);
      setCustomRefundAmountDisplay((defaultHalf / 100).toFixed(2));
    }
  };

  const confirmAction = async () => {
    if (!pendingAction) return;

    const { uniqueId, actionData: s } = pendingAction;
    setShowConfirmation(false);
    setPendingAction(null);

    if (!s) {
      console.error("No action data for", uniqueId);
      setBtnStates((prev) => ({ ...prev, [uniqueId]: { status: "error", message: "No data" } }));
      return;
    }

    console.log("[Refund] calling backend:", s.action, s.platform, uniqueId);
    setBtnStates((prev) => ({ ...prev, [uniqueId]: { status: "loading", message: "" } }));

    try {
      const cancelOrRefundForEntity = httpsCallable(functions, "cancelOrRefundForEntity");

      const payload = {
        email,
        k: secretKeyPuur,
        platform: s.platform,
        action: s.action,
        object: {
          ...s.object,
          refundAmount: s?.action === "refund50" ? Number(customRefundAmount) || 0 : undefined
        }
      };
      console.log("[Refund] payload:", JSON.stringify(payload, null, 2));

      const response = await cancelOrRefundForEntity(payload);
      console.log("[Refund] response:", response.data);

      const result = response.data as any;
      const action = s.action.charAt(0).toUpperCase() + s.action.slice(1);

      if (result.success) {
        const amountLabel =
          s.action === "refund50"
            ? typeof customRefundAmountDisplay === "string"
              ? customRefundAmountDisplay
              : ((Number(customRefundAmount) || 0) / 100).toFixed(2)
            : null;
        const message =
          s.action === "refund50" && amountLabel
            ? `Refund $${amountLabel} done`
            : `${action} done`;
        setBtnStates((prev) => ({ ...prev, [uniqueId]: { status: "success", message } }));
        try {
          await logRefundActivity({
            action: s.action === "cancel" ? "cancel" : "refund",
            detail: `${email} — ${s.platform} — ${message}`,
            uid: getAuth().currentUser?.uid || "",
          });
        } catch {}
      } else {
        const errorMessage = result.message || "Unknown error";
        setBtnStates((prev) => ({ ...prev, [uniqueId]: { status: "error", message: `${action}: ${errorMessage}` } }));
      }
    } catch (error) {
      console.error("[Refund] error:", error);
      setBtnStates((prev) => ({ ...prev, [uniqueId]: { status: "error", message: error.message || "Action failed" } }));
    }
  };

  const cancelAction = () => {
    setShowConfirmation(false);
    setPendingAction(null);
  };

  return (
    <div className="refund">
      <div className="refund__header">
        <h1 className="refund__title">Refundыч</h1>
        <p className="refund__version">v9.1 — Feb 17, 2026</p>
      </div>

      <div className="refund__search">
        <input
          id="email"
          type="text"
          className="refund__input"
          placeholder="Email, userID or Statement Descriptor"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && !isSearching && getDataByEmail()}
          disabled={isSearching}
          required
        />
        <button className="refund__search-btn" onClick={getDataByEmail} disabled={isSearching}>
          {isSearching ? "Searching..." : "Search"}
        </button>
      </div>

      <div className="refund__results">
        {typeof htmlContent === "string" ? (
          <span dangerouslySetInnerHTML={{ __html: htmlContent }} />
        ) : Array.isArray(htmlContent) && htmlContent.some((i) => i?.type === "button" || i?.type === "html") ? (
          htmlContent.map((item) => {
            if (item.type === "html") {
              return <span key={`html-${item.index}`} dangerouslySetInnerHTML={{ __html: item.html }} />;
            }
            const state = btnStates[item.uniqueId];
            if (state?.status === "success") {
              return <span key={item.uniqueId} className="refund__status refund__status--ok">{state.message}</span>;
            }
            if (state?.status === "error") {
              return <span key={item.uniqueId} className="refund__status refund__status--err">{state.message}</span>;
            }
            if (state?.status === "loading") {
              return (
                <span key={item.uniqueId} className="refund__btn-loading">
                  <span className="refund__btn-spinner" />
                </span>
              );
            }
            return (
              <button
                key={item.uniqueId}
                id={item.uniqueId}
                className={item.className}
                disabled={item.isDisabled}
                onClick={() => buttonAction(item.uniqueId)}
              >
                {item.actionText}
              </button>
            );
          })
        ) : (
          htmlContent
        )}
      </div>

      {/* Confirmation Modal */}
      {showConfirmation && (
        <div key="modal-overlay" className="modal-overlay">
          <div key="modal-content" className="modal-content">
            <h3 key="modal-title">Confirm Action</h3>
            <p key="modal-message">
              Are you sure you want to{" "}
              <strong>
                {pendingAction?.actionData?.action === "refund" && "Refund"}
                {pendingAction?.actionData?.action === "refund50" && "Refund"}
                {pendingAction?.actionData?.action === "cancel" && "Cancel"}
              </strong>{" "}
              for {pendingAction?.actionData?.platform}?
            </p>
            {pendingAction?.actionData?.action === "refund50" && (
              <div key="custom-refund-input" className="modal-field">
                <label htmlFor="refund-amount">
                  Refund amount (dollars.cents)
                </label>
                <input
                  id="refund-amount"
                  type="text"
                  inputMode="decimal"
                  pattern="[0-9]*[.]?[0-9]*"
                  className="refund__input"
                  style={{ textAlign: "center" }}
                  value={customRefundAmountDisplay}
                  onChange={(e) => {
                    const raw = (e.target.value || "").replace(/,/g, ".");
                    const filtered = raw.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                    setCustomRefundAmountDisplay(filtered);
                    const cents = Math.max(0, Math.round((Number(filtered) || 0) * 100));
                    setCustomRefundAmount(cents);
                  }}
                />
                <div
                  style={{
                    marginTop: "6px",
                    marginBottom: "12px",
                    fontSize: "0.8125rem",
                    color: "var(--color-text-muted)"
                  }}
                >
                  Default: 50% of remaining (
                  {(() => {
                    const remainingMinor =
                      Number(pendingAction?.actionData?.object?.remaining_minor) || 0;
                    const baseMinor =
                      remainingMinor > 0
                        ? remainingMinor
                        : toMinorUnits(pendingAction?.actionData?.object?.amount);
                    return (Math.max(0, Math.floor(baseMinor / 2)) / 100).toFixed(2);
                  })()}
                  )
                </div>
              </div>
            )}
            <div key="modal-actions" className="modal-actions">
              <button key="cancel-button" className="button-cancel-modal" onClick={cancelAction}>
                Cancel
              </button>
              <button key="confirm-button" className="button-confirm" onClick={confirmAction}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Refund;
